import { Controller } from "stimulus"
import tippy from 'tippy.js';

export default class extends Controller {
    static targets = []

    connect() {
        tippy('[data-tippy-content]', {
            delay: [300, 0],
            animation: 'shift-away-subtle',
            duration: [50, 0],
        });
    }
}